import styled from 'styled-components';

export const WarningRow = styled.div`
  display: table;
  margin-top: 20px;
`;

export const WarningRowItem = styled.div`
  display: table-cell;
  line-height: 1;
  padding-right: 10px;
`;
